export enum ERequestType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}
